export function handleResponse(response) {
  return { data: response.data, message: response.message };
}

export function handleError(error) {
  return error?.message;
}
